import { SORT_DIRECTIONS } from './tableSortDirections';

/**
 * Próximo orden al hacer clic en un encabezado: ascendente → descendente → sin orden.
 * Una columna distinta siempre empieza en ascendente.
 * @param {{key: string, direction: string}|null} current Orden vigente.
 * @param {string} key Columna clickeada.
 * @returns {{key: string, direction: string}|null} Nuevo orden o `null` para limpiarlo.
 */
export const nextTableSort = (current, key) => {
  if (current?.key !== key) return { key, direction: SORT_DIRECTIONS.asc };
  if (current.direction === SORT_DIRECTIONS.asc) return { key, direction: SORT_DIRECTIONS.desc };
  return null;
};
